import { cn } from "@/lib/utils";
import Link from "next/link";

interface Props {
  curPath: string;
  curMouseEnterIdx: number;
  menuList: {
    title: string;
    icon: JSX.Element;
    href: string;
    children: {
      title: string;
      href?: string;
    }[];
  }[];
  idx: number;
}

export default function BigMenu({
  curPath,
  curMouseEnterIdx,
  menuList,
  idx,
}: Props) {
  return (
    <menu
      className={cn(
        "hidden w-full absolute bottom-0 translate-y-[100%] space-x-10 px-24 py-8 bg-[rgba(255,255,255,0.9)] rounded-lg justify-between",
        curMouseEnterIdx === idx && "group-hover/nav:flex"
      )}
    >
      {menuList.map(({ title, children, icon }, idx) => (
        <div className="flex flex-col space-y-3" key={idx}>
          <h4 className="space-x-2 flex items-center">
            {icon}
            <span className="text-[#333333] ">{title}</span>
          </h4>
          <hr className="border-none w-60 h-px bg-[#999999]" />
          <ol className="flex flex-col space-y-3.5">
            {children.map((c, idx) => (
              <li
                className={cn(
                  "text-[#333333] text-[13px] hover:text-[#004EA2]",
                  curPath === c.href && "text-[#004EA2]"
                )}
                key={idx}
              >
                <Link href={c.href ?? ""}>{c.title}</Link>
              </li>
            ))}
          </ol>
        </div>
      ))}
      <div className="w-60"></div>
    </menu>
  );
}
